import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import CrewContainer from '../../layouts-components__common-cases/crew-container';

import CommonUsualText from '../../../common-components/common-usual-text';
import CommonTitle from '../../../common-components/common-title';

const webPracticTechLeaders = {
    crewTitle: 'Вебпрактик',
    crewSubtitle: null,
    crewList: [
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: 'Александр Букуров',
            crewItemSubtitle: 'менеджер проекта',
        },
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: 'Александр Забанов',
            crewItemSubtitle: 'руководитель группы разработки',
        },
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: 'Петр Кленкин',
            crewItemSubtitle: 'backend-разработчик',
        },
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: 'Сергей Буланов',
            crewItemSubtitle: 'backend-разработчик',
        },
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: 'Мария Лапиева',
            crewItemSubtitle: 'frontend-разработчик',
        },
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: 'Николай Цай',
            crewItemSubtitle: 'старший веб-дизайнер',
        },
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: 'Анна Сластен',
            crewItemSubtitle: 'дизайнер',
        },
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: 'Алина Климец',
            crewItemSubtitle: 'контент-менеджер',
        },
        {
            crewItemImg: '/images/svg/tech-leaders/oval-example.svg',
            crewItemTitle: 'Анастасия Суховеева',
            crewItemSubtitle: 'контент-менеджер',
        },
    ],
};

const RVKTechLeaders = {
    crewTitle: 'РВК',
    crewSubtitle: 'Выражаем благодарность:',
    crewList: [
        {
            crewItemImg: null,
            crewItemTitle: 'Юрий Дюгованец',
            crewItemSubtitle:
                'старший руководитель проектов «Центр стратегического планирования и развития РВК»',
        },
        {
            crewItemImg: null,
            crewItemTitle: 'Юрий Фёдоров',
            crewItemSubtitle: 'руководитель службы цифровых коммуникаций',
        },
        {
            crewItemImg: null,
            crewItemTitle: 'Юрий Руренко',
            crewItemSubtitle: 'менеджер цифровых коммуникаций',
        },
    ],
};

const Team = () => {
    return (
        <FullWrapper className="tech-leaders-team">
            <CommonTitle>Команда</CommonTitle>
            <CommonUsualText>
                Каждому клиенту мы&nbsp;предоставляем отдельную проектную команду. Над созданием
                проекта для РВК &laquo;Глобальное технологическое лидерство&raquo; работали
                9&nbsp;человек с&nbsp;нашей стороны и&nbsp;3&nbsp;человека со&nbsp;стороны
                заказчика:
            </CommonUsualText>
            <CrewContainer container={webPracticTechLeaders} />
            <CrewContainer container={RVKTechLeaders} />
        </FullWrapper>
    );
};

export default Team;
